var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "102.39px",
    height: "122.88px",
    viewBox: "0 0 102.39 122.88",
    enableBackground: "new 0 0 102.39 122.88",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.529,84.792c6.151,3.507,10.299,10.125,10.299,17.713 c0,11.252-9.123,20.375-20.375,20.375s-20.375-9.123-20.375-20.375c0-7.438,3.986-13.944,9.938-17.502 c-0.581-12.169,0.074-37.095,0.193-46.967C4.107,34.516,0,27.925,0,20.375C0,9.122,9.123,0,20.375,0 c11.253,0,20.376,9.122,20.376,20.375c0,7.558-4.116,14.155-10.228,17.672v23.932c7.833-2.279,15.63-2.077,22.951-1.887 c3.04,0.079,5.972,0.156,8.801-0.066c5.989-0.471,10.397-4.068,10.645-21.415c-6.687-3.342-11.28-10.252-11.28-18.236 C61.64,9.122,70.762,0,82.016,0c11.252,0,20.374,9.122,20.374,20.375c0,7.131-3.664,13.406-9.212,17.046 C93.035,71.855,80.73,78.916,63.861,80.242c-3.343,0.263-7.034,0.167-10.862,0.067c-7.579-0.198-15.893-0.415-22.476,3.804 C30.523,84.336,30.526,84.563,30.529,84.792L30.529,84.792z M82.016,12.688c4.244,0,7.686,3.441,7.686,7.686 c0,4.245-3.441,7.687-7.686,7.687c-4.246,0-7.688-3.442-7.688-7.687C74.328,16.13,77.77,12.688,82.016,12.688L82.016,12.688z M20.375,12.688c4.245,0,7.687,3.441,7.687,7.686c0,4.245-3.441,7.687-7.687,7.687s-7.686-3.442-7.686-7.687 C12.689,16.13,16.13,12.688,20.375,12.688L20.375,12.688z M20.452,94.817c4.245,0,7.687,3.442,7.687,7.688 s-3.441,7.686-7.687,7.686s-7.687-3.44-7.687-7.686S16.207,94.817,20.452,94.817L20.452,94.817z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGit);
export default __webpack_public_path__ + "static/media/icon_git.f3cf1b62726c31a98b74e28302afa26e.svg";
export { ForwardRef as ReactComponent };